module.exports = __webpack_public_path__ + "img/welcome.340d98bc.jpg";